<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <a
              :href="'/Print/ProductReturnForm/' + this.$route.params.id"
              target="_blank"
              class="btn btn-sm btn-warning kt-margin-r-10"
            >
              <i class="fa fa-print"></i>
              <span class="kt-hidden-mobile">พิมพ์</span>
            </a>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <!-- Begin:วันที่เอกสาร input -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="">วันที่เอกสาร :</label>
                  <span class="form-control-plaintext">{{
                    ubpReqDateString
                  }}</span>
                </div>
              </div>
              <!-- End:วันที่เอกสาร input -->

              <!-- begin: เลขที่เอกสาร -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="">เลขที่เอกสาร:</label>
                  <span class="form-control-plaintext">{{ ubpDocNo }}</span>
                </div>
              </div>
              <!-- end: เลขที่เอกสาร -->

              <!-- begin: ผู้ขอเบิก/ยืม -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="">ผู้ขอเบิก/ยืม:</label>
                  <span class="form-control-plaintext">{{ ubpBorrower }}</span>
                </div>
              </div>
              <!-- end: ผู้ขอเบิก/ยืม -->

              <!-- begin: ตัวแทนจำหน่าย/หน่วย -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="">ตัวแทนจำหน่าย/หน่วยงาน:</label>
                  <span class="form-control-plaintext">{{ ubpAgentCode }}</span>
                </div>
              </div>
              <!-- end: ตัวแทนจำหน่าย/หน่วย -->

              <!-- Begin:ประเภทใบคำร้องขอ input -->
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="col-3 col-form-label ">ประเภทใบคำร้องขอ:</label>
                  <div class="col-9">
                    <div class="kt-checkbox-inline">
                      <label
                        class="kt-checkbox"
                        v-for="(ubpRequestTypeOption,
                        ubp) in ubpRequestTypeOptions"
                        :key="ubp"
                      >
                        <input
                          type="checkbox"
                          :id="ubpRequestTypeOption.id"
                          :value="ubpRequestTypeOption.id"
                          checked
                          v-model="ubpRequestType"
                          :disabled="true"
                        />
                        {{ ubpRequestTypeOption.text }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End:ประเภทใบคำร้องขอ input -->

              <!-- Begin:หมวดหมู่สินค้า input -->
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="col-3 col-form-label ">หมวดหมู่สินค้า:</label>
                  <div class="col-9">
                    <div class="kt-radio-inline">
                      <label
                        class="kt-radio rea"
                        v-for="(ubpProductGroupOption,
                        index) in ubpProductGroupOptions"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :id="ubpProductGroupOption.id"
                          :value="ubpProductGroupOption.id"
                          v-model="ubpProductGroup"
                          @change="onProductGroupChange($event)"
                          :disabled="true"
                        />
                        {{ ubpProductGroupOption.text }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End:หมวดหมู่สินค้า input -->

              <!-- Begin: table -->
              <div id="Activity" class="col-xl-12 table-responsive">
                <table
                  class="table table-sm table-striped table-bordered table-hover table-checkable"
                  style="min-width:2000px;"
                >
                  <thead>
                    <tr>
                      <th class="all text-center" style="width: 2%;">ลำดับ</th>
                      <th class="all text-center" style="width: 5%;">
                        วันที่จ่ายสินค้า
                      </th>
                      <th class="all text-center" style="width: 5%;">สถานะ</th>
                      <th class="all text-center" style="width: 8%;">
                        ประเภทสินค้า
                      </th>
                      <th class="all text-center" style="width: 10%;">
                        ชื่อสินค้า
                      </th>
                      <th class="all text-center" style="width: 8%;">
                        โควต้า(แบรนด์)
                      </th>
                      <th class="all text-center" style="width: 5%;">จำนวน</th>
                      <th class="all text-center" style="width: 10%;">
                        ตัวแทนจำหน่าย
                      </th>
                      <th class="all text-center" style="width: 10%;">
                        ชื่อร้านค้า/กิจกรรม
                      </th>
                      <th class="all text-center" style="width: 10%;">
                        หมายเหตุกิจกรรม
                      </th>
                      <th class="all text-center" style="width: 5%;">
                        วันที่กำหนดคืน
                      </th>
                      <th class="all text-center" style="width: 5%;">
                        จำนวนคงค้าง
                      </th>
                      <th class="all text-center">คืน</th>
                      <th class="all text-center">ชำรุด</th>
                      <th class="all text-center">สูญหาย</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, i) in plItems">
                      <product-return-item-row
                        ref="plItems"
                        :key="i"
                        :rowIndex="i"
                        :item="item"
                      ></product-return-item-row>
                    </template>
                  </tbody>
                </table>
              </div>
              <!-- End: table -->
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>หมายเหตุ:</label>
                  <textarea
                    placeholder="หมายเหตุ"
                    class="form-control"
                    v-model="ubpRemark"
                    rows="3"
                  ></textarea>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
            <i class="la la-save"></i> {{ isSubmitting ? 'กำลังบันทึกข้อมูล...' : 'บันทึกข้อมูล' }}
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";
import ProductReturnItemRow from "./JobBorrowProductReturnItemRow";

export default {
  components: {
    select2,
    datepicker,
    ProductReturnItemRow,
  },
  data: function() {
    var self = this;

    return {
      isChange: false,
      plItems: [],
      plItemsTemp: [],
      i: 0,
      ubpDocNo: null,
      ubpProductLoanId: null,
      ubpBorrower: null,
      ubpBorrowerId: null,
      //ubpCompanyProfile: null,
      ubpAgentCode: null,
      ubpRepresentName: null,
      ubpRepresentTel: null,
      ubpReqDate: null,
      ubpReqDateString: null,
      ubpRequestType: [],
      ubpRequestTypeOptions: [],
      ubpProductGroup: null,
      ubpProductGroupId: null,
      ubpProductGroupOptions: [],
      ubpRemark: null,
      ubpIsAgent: false,
      ubpIsApprove: false,
      ubpStatusCode: null,
      ubpIsEdit: false,
      isSubmitting: false,

      /* begin: Set Select2 Options*/
      //   ubpAgentOptions: {
      //     placeholder: "กรุณาเลือก",
      //     allowClear: true,
      //     ajax: {
      //       url: "/Api/ProductLoan/Select2SearchAgentOrg",
      //       data: function(params) {
      //         var query = {
      //           userId: self.ubpBorrower,
      //           search: params.term,
      //           page: params.page || 1
      //         };
      //         return query;
      //       },
      //       processResults: function(data, params) {
      //         return {
      //           results: data.results,
      //           pagination: {
      //             more: data.more
      //           }
      //         };
      //       },
      //       transport: function(params, success, failure) {
      //         params.beforeSend = function(request) {
      //           request.setRequestHeader(
      //             "Authorization",
      //             "Bearer " + self.$root.user.access_token
      //           );
      //         };
      //         var $request = $.ajax(params);
      //         $request.then(success);
      //         $request.fail(failure);
      //         return $request;
      //       }
      //     }
      //   },
      //   ubpBorrowerOptions: {
      //     placeholder: "กรุณาเลือก",
      //     allowClear: true,
      //     ajax: {
      //       delay: 300,
      //       url: "/Api/ProductLoan/Select2Borrower",
      //       data: function(params) {
      //         var query = {
      //           userId: "",
      //           search: params.term,
      //           page: params.page || 1
      //         };
      //         return query;
      //       },
      //       processResults: function(data, params) {
      //         return {
      //           results: data.results,
      //           pagination: {
      //             more: data.more
      //           }
      //         };
      //       },
      //       transport: function(params, success, failure) {
      //         params.beforeSend = function(request) {
      //           request.setRequestHeader(
      //             "Authorization",
      //             "Bearer " + self.$root.user.access_token
      //           );
      //         };
      //         var $request = $.ajax(params);
      //         $request.then(success);
      //         $request.fail(failure);
      //         return $request;
      //       }
      //     }
      //   }
      /* end: Set Select2 Options*/
    };
  },

  methods: {
    formSubmit: function(e) {
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      e.preventDefault();

      let router = this.$router;
      let self = this;

      var pItems = [];
      self.plItems.forEach((element) => {
        pItems.push({
          ProductLoanItemId: element.plProductLoanItemId,
          MaterialCode: element.plProductId,
          AgentCode: element.plAgentCode,
          QuotaId: element.plQuotaId,
          Qty: element.plQty,
          Damaged: element.plDamaged > 0 ? element.plDamaged : 0,
          Lost: element.plLost > 0 ? element.plLost : 0,
          Return: element.plReturn > 0 ? element.plReturn : 0,
          // Damaged: element.plDamaged != null ? element.plDamaged : 0,
          // Lost: element.plLost != null ? element.plLost : 0,
          // Return: element.plReturn != null ? element.plReturn : 0,
        });
      });

      var jItems = {
        ProductLoanHeaderId: self.ubpProductLoanId,
        RequestDate: self.ubpReqDate,
        BorrowerId: self.ubpBorrowerId,
        Remark: self.ubpRemark,
        Items: pItems,
      };

      axios({
        method: "post",
        url: "/Api/ProductLoan/OpenJobReturn",
        data: {
          Obj: jItems,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
          this.isSubmitting = false;
        });
    },
    onProductGroupChange: function() {
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
        this.ubpProductGroupId = "1";
      }
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
        this.ubpProductGroupId = "2";
      }
    },
    onRequestTypeChange: function(e) {},
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    //Begin :Get Value RequestType CheckBox
    axios
      .get("/Api/Variables/Options", {
        params: {
          search: "PRODUCT_LOAN_REQUEST_TYPE",
        },
      })
      .then(function(response) {
        if (response.status == 200) {
          if (
            response.data.results != null &&
            response.data.results.length > 0
          ) {
            for (let i = 0; i < response.data.results.length; i++) {
              self.ubpRequestTypeOptions.push({
                id: response.data.results[i].id,
                text: response.data.results[i].text,
              });
            }
          }
          return self.ubpRequestTypeOptions;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    //End :Get Value RequestType CheckBox

    //Begin :Get Value ProductGroup Radio checkbox
    axios
      .get("/Api/Variables/Options", {
        params: {
          search: "PRODUCT_LOAN_PRODUCT_GROUP",
        },
      })
      .then(function(response) {
        if (response.status == 200) {
          if (
            response.data.results != null &&
            response.data.results.length > 0
          ) {
            for (let i = 0; i < response.data.results.length; i++) {
              self.ubpProductGroupOptions.push({
                id: response.data.results[i].id,
                text: response.data.results[i].text,
              });
            }
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    //End :Get Value ProductGroup Radio checkbox

    axios
      .get("/Api/ProductLoan/GetJobReturn/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null) {
            self.ubpProductLoanId = response.data.productLoanHeaderId;
            self.ubpDocNo = response.data.requestDocNo;
            self.ubpRepresentName = response.data.representativeName;
            self.ubpRepresentTel = response.data.representativeNameL;
            self.ubpStatusCode = response.data.productLoanStatusCode;
            self.ubpIsApprove = response.data.isApprove;
            self.ubpIsAgent = response.data.isAgent;
            self.ubpBorrower = response.data.requestUser;
            self.ubpBorrowerId = response.data.requestUserId;
            self.ubpAgentCode = response.data.agentOrgName;
            self.ubpRemark = response.data.remark;

            self.ubpRequestType = response.data.requestTypeList;
            self.ubpProductGroup = response.data.productGroupId;

            if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
              self.ubpProductGroupId = "1";
            }
            if (
              self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS"
            ) {
              self.ubpProductGroupId = "2";
            }

            self.ubpReqDateString = response.data.requestDateFormat;
            self.ubpReqDate = response.data.requestDate;
            if (response.data.productItem.length > 0) {
              for (let i = 0; i < response.data.productItem.length; i++) {
                var item = response.data.productItem[i];
                let IsDisabled = false;
                if(item.outstanding < 1){
                  IsDisabled = true
                }
                self.plItems.push({
                  //   plProductId: item.materialCode,
                  //   plProductType: item.productTypeId,
                  plProductLoanItemId: item.productLoanItemId,
                  plStatus: item.statusName,
                  plProductType: item.productTypeName,
                  plProductId: item.materialCode,
                  plProductName:
                    item.materialName + " [" + item.materialCode + "]",
                  plQuota: item.quotaName,
                  plQuotaId: item.quotaId,
                  plAgent:
                    item.agentCode != null
                      ? "[" + item.agentCode + "] " + item.agentCodeName
                      : "ไม่ระบุ",
                  plAgentCode: item.agentCode,
                  plShopActivityName: item.shopActivityName,
                  plQty: item.qty,
                  plActivityRemark: item.activityRemark,
                  plReturnDate: item.returnDateFormat,
                  plOutstanding: item.outstanding,
                  plReturn: null,
                  plDamaged: null,
                  plLost: null,
                  plIsHide: item.hasBarcode,
                  plReqDateString: response.data.requestDateFormat,
                  IsDisabled: IsDisabled,
                });
              }
            } else {
              Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลรายการยืม", "warning");
              router.go(-1);
            }
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed

        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Borrow/JobBorrowProductReturn.vue